module.exports = __webpack_public_path__ + "media/images/icons/SVG/022-4d6ecf023bef9db9c633bac35383f192.svg";